<script lang="ts">
	import { toast } from '$lib/stores/toast.svelte';
</script>

<!--
	v5.3.3 BDES-47 P1-A11Y-1 — Per-child live region.
	Each toast owns its own role + aria-live based on `kind`. Errors are
	assertive so VoiceOver interrupts the current utterance (e.g. on a save
	failure mid-confirm); success/info/warning stay polite. Stack container
	no longer carries a live region — the previous polite-on-stack pattern
	suppressed assertive children. WCAG 4.1.3 + ARIA APG status-vs-alert.
-->
<div class="toast-stack" aria-atomic="false">
	{#each toast.messages as msg (msg.id)}
		<div
			class="toast toast-{msg.kind}"
			role={msg.kind === 'error' ? 'alert' : 'status'}
			aria-live={msg.kind === 'error' ? 'assertive' : 'polite'}
		>
			<span class="toast-text">{msg.text}</span>
			{#if msg.undo}
				<button
					type="button"
					class="toast-undo"
					onclick={() => {
						msg.undo?.();
						toast.dismiss(msg.id);
					}}
				>
					Undo
				</button>
			{/if}
		</div>
	{/each}
</div>

<style>
	.toast-stack {
		position: fixed;
		bottom: calc(env(safe-area-inset-bottom) + 88px);
		left: var(--space-4);
		right: var(--space-4);
		display: flex;
		flex-direction: column;
		gap: var(--space-2);
		z-index: 40;
		pointer-events: none;
	}

	.toast {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: var(--space-3);
		padding: var(--space-3) var(--space-4);
		background: var(--color-bg-container);
		border: 1px solid var(--color-border-default);
		border-radius: var(--radius-md);
		color: var(--color-text-primary);
		font-size: 14px;
		pointer-events: auto;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
	}

	.toast-success {
		border-left: 3px solid var(--color-success);
	}

	.toast-warning {
		border-left: 3px solid var(--color-warning);
	}

	.toast-error {
		border-left: 3px solid var(--color-danger);
	}

	.toast-info {
		border-left: 3px solid var(--color-info);
	}

	.toast-text {
		flex: 1;
	}

	.toast-undo {
		color: var(--color-accent-hover);
		font-weight: 600;
		padding: var(--space-1) var(--space-2);
		border-radius: var(--radius-sm);
	}

	.toast-undo:hover,
	.toast-undo:focus-visible {
		background: rgba(96, 165, 250, 0.12);
	}
</style>
